export default __webpack_public_path__ + "static/media/monitor.678fbcd8.png";